import type { KeyPoseEditingPreviewRecord } from './types';

export type KeyPoseDragPreviewState = {
  keyPoseId: string | null;
  preview: KeyPoseEditingPreviewRecord | null;
};

let dragPreviewState: KeyPoseDragPreviewState = {
  keyPoseId: null,
  preview: null,
};

export function getKeyPoseDragPreviewState(): KeyPoseDragPreviewState {
  return dragPreviewState;
}

export function setKeyPoseDragPreview(
  keyPoseId: string,
  preview: KeyPoseEditingPreviewRecord,
) {
  dragPreviewState = { keyPoseId, preview };
}

export function clearKeyPoseDragPreview() {
  dragPreviewState = { keyPoseId: null, preview: null };
}
